import { GET_ORDER_PERIODS } from '../actions/types';

const initialState = {
  list: []
};

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ORDER_PERIODS: {
      return { ...state, ...{ list: action.orderPeriodsData } };
    }
    default:
      return state;
  }
}
